export default __webpack_public_path__ + "static/carmela-troncoso-dc13f5a911be8eafee56fbcacb558d73.jpg";